@use "@swisspost/design-system-styles/variables/color";
@use "@swisspost/design-system-styles/functions";
@use "../../utils/utils.scss";

:host {
  --separator-display: none;
  --separator-height: 100%;

  display: flex;
  align-items: center;
  align-self: stretch;

  &::before {
    display: var(--separator-display);
    height: var(--separator-height);
    border-left: 1px solid color.$gray-10;
    content: '';
  }
}

.lang-btn {
  display: flex;
  align-items: center;
  height: 100%;
  padding: 0 1rem;
  border: none;
  box-shadow: none;
  background: none;
  text-transform: uppercase;
  cursor: pointer;
  color: rgba(color.$black, 0.8);

  &:hover,
  &:focus {
    color: black;
  }

  svg {
    width: 1.5em;
    height: 1.5em;
    transition: transform 250ms;

    &.rotated {
      transform: rotate(180deg);
    }
  }
}

.language-switch {
  position: relative;
  align-self: stretch;
  height: 100%;

  &.list {
    margin-top: 1.5rem;
    display: flex;
    align-items: center;
  }
}

.current-language {
  text-transform: uppercase;
  border-right: 1px solid color.$gray-20;
  padding: 0.5rem 1rem 0.5rem 0;
}

.language-switch-dropdown {
  .dropdown & {
    position: absolute;
    top: 100%;
    width: 100%;
    background: white;
    box-shadow: 0 1px 2px rgb(0 0 0 / 20%), 0 2px 6px 2px rgb(0 0 0 / 10%);
    z-index: 1;
    transform: scale(0.1);
    transform-origin: center top;
    transition: transform 0.1s;
    margin-top: var(--language-dropdown-margin-top);

    @media (prefers-reduced-motion: reduce) {
      transition: none;
    }

    &.open {
      transform: scale(1);
    }
  }

  ul {
    @extend %no-list;

    .list & {
      display: flex;

      > li + li {
        border-left: 1px solid color.$gray-20;
      }
    }
  }

  a,
  button {
    @extend %nav-link;

    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: functions.px-to-rem(48px);
    padding: 0 0.25rem;
    text-transform: uppercase;
    cursor: pointer;
    transition: background-color 200ms, color 200ms;

    &:hover,
    &:focus {
      background: color.$gray-background;
    }

    span {
      // Worst case scenario
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
    }

    .list & {
      color: black;
      height: auto;
      padding: 0.5rem 1rem;
    }
  }
}
